import { ChartLine } from '@phosphor-icons/react'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import Tooltip from 'ui/atoms/Tooltip'
import ButtonIcon from 'ui/ButtonIcon'

import { ZentakeContext } from '@/utils/ZentakeContext'

type Props = {
  resourceId: string | number
  resourceEnabled: boolean
}

export const FormControlsAnalyticsFormButton = ({
  resourceId,
  resourceEnabled,
}: Props) => {
  const { teamDetails } = useContext(ZentakeContext)
  const history = useHistory()
  const onPublicForm = (e: MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    history.push(`/forms/analytics/${resourceId}`)
  }

  if (!teamDetails?.analytics) return null

  return (
    <Tooltip label="Analytics">
      <p>
        <ButtonIcon
          rounded
          className={undefined}
          disabled={!resourceEnabled}
          hoverColor={undefined}
          loading={undefined}
          onClick={onPublicForm}
        >
          <ChartLine className="text-base" weight="bold" />
        </ButtonIcon>
      </p>
    </Tooltip>
  )
}
